export default __webpack_public_path__ + "static/media/pos-pro-18.906696fa.jpg";